// extracted by mini-css-extract-plugin
export var list = "question-list-module--list--hOoWb";